/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React, { useEffect, useRef, useState } from "react";
import { CloseIcon, DoctorVisitIcon, DropOffIcon } from "../../../components/Icons";
import { useModal } from "../../../context/ModalContext";
import { StyledBookingFlowButton } from "../../containers/BookingScheduleContainer/BookingScheduleContainer.style";
import { CREATE_BOOKING_TYPE, MODALS } from "../../../config/params";
import { usePetStore } from "../../../hooks/redux-hooks/pet-store/pet-store.service";
import { useAppointmentStore } from "../../../hooks/redux-hooks/appointment-store/appointment.store";
import { useUrgentVisitStore } from "../../../hooks/redux-hooks/urgent-visit-store/urgent-visit.store";
import { UrgentVisitStep } from "../../../state/urgent-visit";
import { BookingScheduleContainer, ConfirmDropoffToggleContainer, PetSelectionContainer } from "../../containers";
import ConfirmUrgentVisitToggleContainer from "../../containers/ConfirmUrgentVisitToggleContainer/ConfirmUrgentVisitToggleContainer";
import { useOverdueInvoiceStore } from "../../../hooks/redux-hooks/overdue-invoice-store/overdue-invoice.store";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CustomLinearProgressBar from "../ExpressVisitModal/CustomLinearProgressBar";
import BookingReviewContainer from "../../containers/BookingReviewContainer/BookingReviewContainer";
import { useBookingAppointmentTypeStore, useBookingReasonsNavigation } from "../../../hooks";
import { MIXPANEL_EVENTS } from "../../../config/mixPanelEvents";
import { userActivityLogger } from "../../../utils/mixpanel";
import { useUserStore } from "../../../hooks/redux-hooks/user-store/user.store";
import { getOverdueCount, getSelectedSocReasonsCount } from "../../../utils/mixpanelHelperFunctions";
import { socStatusMapper } from "../../../utils/SOCUtils";
import { useSocDatByPetReminderCard } from "../../../services/Standard-of-care/standard-of-care.service";
import { fromUnixToFullDateNum } from "../../../utils/unix-timestamp";
import ReasonForVisitContainer from "../../containers/ReasonForVisitContainer/ReasonForVisitContainer";
import { formatReasonPetNames } from "../../../utils/bookingFlow";
import { useAppointmentCreateV2 } from "../../../services/create-appointment-v2/create-appointment-v2.service";
import SelectedTimeUnavailableModal from "../SelectedTimeUnavailableModal/SelectedTimeUnavailableModal";

const BookAVisitUpdatedModal = () => {
  const { user } = useUserStore();
  const { closeModal, openModal, setAppointmentErrorCode } = useModal();
  const [activeStep, setActiveStep] = useState<number>(0);
  const { petList } = usePetStore();
  const { selectedPets, appointmentForm, setPromoCodeData, resetCurrentBookingStep,
    setAppointmentsForm, setReasonForVisit, reasonForVisit, promoCode, currentStep } = useAppointmentStore();
  const [selectedSlot, setSelectedSlot] = useState<string>("");
  const [selectedDate, setSelectedDate] = useState<string>("");
  const { isBookingBlocked }=useOverdueInvoiceStore();
  const { petsReasonSelection, currentNavigationIndex, setCurrentNavigationIndex, setPetsReasonSelection, resetReasonsNavigationStore }=useBookingReasonsNavigation();
  const { createAppointmentV2, appointmentCreatedV2 } = useAppointmentCreateV2();
  const [disableButton, setDisableButton] = useState<boolean>(false);
  const [availableDate, setAvailableDate]=useState< {
      weekday: string;
      month: string;
      day: string;
      year: string;
      time: string;
  }>();
  const [bookingDate, setBookingDate]=useState<string>("");
  const { bookingAppointmentType } = useBookingAppointmentTypeStore();
  const {
    resetUrgentVisit,
    setSelectedPets: setUrgentSelectedPets,
    setStep: setUrgentStep,
  } = useUrgentVisitStore();
  const { socDataByPet } = useSocDatByPetReminderCard();
  const scrollRef = useRef<HTMLDivElement>(null);

  const handleCloseModal = ()=>{
    openModal(MODALS.CANCEL_BOOK_A_VISIT);
  };

  const handleConfirmBooking = () => {
    // handleMixPanelLog(MIXPANEL_EVENTS.USER_VISIT_REASON_SELECTED); // Overdue not used Temporary, unconmment if used later
    handleMixPanelLog(MIXPANEL_EVENTS.BOOK_A_VISIT_CONFIRM);
    createAppointmentV2();
    localStorage.removeItem("isWebUser");
  };

  const handleReasonTextFormat = (reasons: string, description: string) =>{
    let reasonsTextFormat = "";

    if (description.length) {
      reasonsTextFormat = `Description:${description},reasons:${reasons}`;
    } else {
      reasonsTextFormat = reasons;
    }

    return reasonsTextFormat;
  };

  const handleReasonCtaClick = () => {
    switch (petsReasonSelection[currentNavigationIndex]?.currentSelectionState) {
    case 0:
      if (petsReasonSelection[currentNavigationIndex]?.selectedReasonCategory.length) {
        const updatedPetReasonSelection = petsReasonSelection.map((pet, index) =>
          index === currentNavigationIndex ? { ...pet, currentSelectionState: 1 as 1 } : pet,
        );

        setPetsReasonSelection(updatedPetReasonSelection);
        handleMixPanelLog(MIXPANEL_EVENTS.BOOK_A_VISIT_REASON_CATEGORY);
      }
      break;
    case 1:
      if (petsReasonSelection[currentNavigationIndex]?.selectedReasons.length) {
        onReasonSelection({
          petId: petsReasonSelection[currentNavigationIndex]?.petId,
          reasons: handleReasonTextFormat(
            petsReasonSelection[currentNavigationIndex]?.selectedReasons?.join(","), petsReasonSelection[currentNavigationIndex]?.additionalDescription),
          anything: "",
        });
        if ((currentNavigationIndex + 1) === petsReasonSelection.length) {
          handleStep(4);
        } else {
          setCurrentNavigationIndex(currentNavigationIndex+1);
        }
        handleMixPanelLog(MIXPANEL_EVENTS.VISIT_REASON_SELECT);
      }
      break;
    default:
      break;
    }
  };
  const handleReasonsBackStep = () => {
    switch (petsReasonSelection[currentNavigationIndex]?.currentSelectionState) {
    case 0:
      if (currentNavigationIndex === 0) {
        handleStep(1);
      } else {
        setCurrentNavigationIndex(currentNavigationIndex-1);
      }
      break;
    case 1:

      const updatedPetReasonSelection = petsReasonSelection.map((pet, index) =>
        index === currentNavigationIndex ? { ...pet, currentSelectionState: 0 as 0 } : pet,
      );

      setPetsReasonSelection(updatedPetReasonSelection);
      break;
    default:
      break;
    }
  };

  const onReasonSelection = (reason: any)=>{
    const reasonVisitUpdatedList = {
      ...reasonForVisit,
      [reason.petId]: { reasons: reason.reasons, anything: reason.anything,
        socReasons: reasonForVisit[reason.petId]?.socReasons,
      },
    };

    setReasonForVisit(reasonVisitUpdatedList);
  };

  const handleCtaClick = ()=>{
    switch (activeStep) {
    case 0:
      handleStep();
      break;
    case 1:
      handleStep();
      break;
    case 2:
      handleReasonCtaClick();
      break;
    case 4:
      handleConfirmBooking();
      break;
    default:
      break;
    }
    // scroll the container to top on click
    const element = scrollRef.current;

    element?.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  const handleBackStep = ()=>{
    switch (activeStep) {
    case 1:
      handleStep(0);
      break;
    case 2:
      handleReasonsBackStep();
      break;
    case 3:
      handleStep(2);
      break;
    case 4:
      handleStep(2);
      break;
    case 5:
      handleStep(2);
      break;
    default:
      break;
    }
  };

  const getCtaText = ()=>{
    switch (activeStep) {
    case 4:
      return "Confirm Booking";
    default:
      return "Continue";
    }
  };

  const handleReasonsCtaValidation = ()=>{
    if (disableButton) {
      return true;
    }

    switch (petsReasonSelection[currentNavigationIndex]?.currentSelectionState) {
    case 0:
      if (petsReasonSelection[currentNavigationIndex]?.selectedReasonCategory.length) {
        return false;
      } else {
        return true;
      }
    case 1:
      if (petsReasonSelection[currentNavigationIndex]?.selectedReasons.length) {
        return false;
      } else {
        return true;
      }
    default:
      return true;
    }
  };

  const disableValidation = (step: number): boolean => {
    switch (step) {
    case 0:
      return !selectedPets?.length;
    case 1:
      return appointmentForm?.time ? false : true;
    case 2:
      return handleReasonsCtaValidation();
    case 4:
      return isBookingBlocked;
    default:
      return false;
    }
  };


  const getSocData = (petId: string) => {
    if (socDataByPet) {
      return socDataByPet.find((socData: { animalId: string; }) => socData.animalId == petId)?.items;
    }
  };

  const hasSocData = (petId: string) => {
    const socData = getSocData(petId);
    let hasData = false;

    if (socData) {
      Object.entries(socData).map(([category, data], index) => {
        if (!category.startsWith("_") && data.length && data.some((item: any) => item.status !== "Current")) {
          hasData = true;
        }
      });
    }

    return hasData;
  };

  const isPetOverDue = () => {
    return hasSocData(petsReasonSelection[currentNavigationIndex].petId);
  };

  const getSelectedReasons = () => {
    const selectedReasons = petsReasonSelection[currentNavigationIndex]?.selectedReasons.join(", ");
    const hasDescription = petsReasonSelection[currentNavigationIndex]?.additionalDescription;

    return `${hasDescription ? `Description: ${petsReasonSelection[currentNavigationIndex]?.additionalDescription}, Reasons: ${selectedReasons}` : `Reasons: ${selectedReasons}`}`;
  };
  const handleMixPanelLog = (event: string, referredFromPage?: string) => {
    const appointmentCategory = bookingAppointmentType === CREATE_BOOKING_TYPE.DROPOFF_BOOKING ?
      "drop_off" : "dvm";

    switch (event) {
    case MIXPANEL_EVENTS.FIND_AVAILABILITY:
      userActivityLogger(MIXPANEL_EVENTS.FIND_AVAILABILITY, {
        appointment_category: appointmentCategory,
        referred_from: referredFromPage ? referredFromPage : "others",
        date: selectedDate,
        time_slot: selectedSlot,
        pet_name: selectedPets.map((pet) => pet.name).join(","),
        no_of_pets: selectedPets.length || 1,
        owner_type: (petList?.length ?? 0) <= 1 ? "single_pet" : "multipet",
        appt_type: bookingAppointmentType === CREATE_BOOKING_TYPE.DROPOFF_BOOKING ? "drop_off" : "in_room_visit",
      });
      break;

    case MIXPANEL_EVENTS.USER_CONFIRM_DROP_OFF_APPOINTMENT:
      userActivityLogger(MIXPANEL_EVENTS.USER_CONFIRM_DROP_OFF_APPOINTMENT, {
        appointment_category: "drop_off",
        date: selectedDate,
        time_slot: selectedSlot,
        pet_name: selectedPets.map((pet) => pet.name).join(","),
      });
      break;
    case MIXPANEL_EVENTS.USER_SWITCH_TO_IN_ROOM_VISIT:
      userActivityLogger(MIXPANEL_EVENTS.USER_SWITCH_TO_IN_ROOM_VISIT, {
        appointment_category: "dvm",
        pet_name: selectedPets.map((pet) => pet.name).join(","),
        referred_from_page: referredFromPage,
      });
      break;

    case MIXPANEL_EVENTS.USER_SWITCH_TO_DROP_OFF:
      userActivityLogger(
        MIXPANEL_EVENTS.USER_SWITCH_TO_DROP_OFF,
        {
          appointment_category: "drop_off",
          pet_name: selectedPets.map((pet) => pet.name).join(","),
          referred_from_page: referredFromPage,
        },
      );
      break;
    case MIXPANEL_EVENTS.VISIT_REASON_SELECT: userActivityLogger(MIXPANEL_EVENTS.VISIT_REASON_SELECT, {
      appointment_category: appointmentCategory,
      owner_type: petList?.length==1?"single_pet":"multipet",
      pet_name: formatReasonPetNames([selectedPets.filter((pet)=>pet.id ===
        petsReasonSelection[currentNavigationIndex]?.petId)[0]?.name]),
      appt_type: bookingAppointmentType === CREATE_BOOKING_TYPE.DROPOFF_BOOKING ? "drop_off" : "in_room_visit",
      reason_selected: getSelectedReasons(),
      overdue_status: isPetOverDue(),
    });
      break;
    case MIXPANEL_EVENTS.BOOK_A_VISIT_REASON_CATEGORY:
      userActivityLogger(MIXPANEL_EVENTS.BOOK_A_VISIT_REASON_CATEGORY, {
        appointment_category: appointmentCategory,
        date: selectedDate,
        pet_name: formatReasonPetNames([selectedPets.filter((pet)=>pet.id ===
                      petsReasonSelection[currentNavigationIndex]?.petId)[0]?.name]),
        time_slot: appointmentForm?.selectedSlotLabel,
        owner_type: (petList?.length ?? 0) <= 1 ? "single_pet" : "multipet",
        reason_category_type: petsReasonSelection[currentNavigationIndex].selectedReasonCategory,
        overdue_status: isPetOverDue(),
      });
      break;
      // Overdue not used Temporary, unconmment if used later
    // case MIXPANEL_EVENTS.USER_VISIT_REASON_SELECTED:
    //   selectedPets.forEach((pets)=>{
    //     userActivityLogger(MIXPANEL_EVENTS.USER_VISIT_REASON_SELECTED, {
    //       no_of_pets: selectedPets.length || 1,
    //       pet_name: pets.name,
    //       soc_overdue: socDataByPet?getOverdueCount(socDataByPet, pets.id)?"yes":"no":"no",
    //       total_overdue: socDataByPet?getOverdueCount(socDataByPet, pets.id):0,
    //       no_of_unchecked: socDataByPet?(getOverdueCount(socDataByPet,
    //         pets.id)-getSelectedSocReasonsCount(reasonForVisit, pets.id)):0,
    //       no_of_checked: getSelectedSocReasonsCount(reasonForVisit, pets.id),
    //     });
    //   });
    //   break;
    case MIXPANEL_EVENTS.BOOK_A_VISIT_CONFIRM:
      userActivityLogger(MIXPANEL_EVENTS.BOOK_A_VISIT_CONFIRM, {
        appointment_category: appointmentCategory,
        date: bookingDate,
        time_slot: selectedSlot,
        owner_type: petList&&petList?.length>1?"multipet":"single_pet",
        user_type_new: "no",
        reason: reasonForVisit,
        no_of_pets: selectedPets.length || 1,
        is_promo_used: promoCode && promoCode?.length > 0 ? true : false,
        promocode: promoCode && promoCode?.join(", "),
        appt_type: bookingAppointmentType === CREATE_BOOKING_TYPE.DROPOFF_BOOKING ? "drop_off" : "in_room_visit",
      });
      break;
    default:
      break;
    }
  };

  const handleStep = (step?: number) => {
    if (activeStep == 1) {
      handleMixPanelLog(MIXPANEL_EVENTS.FIND_AVAILABILITY);
    }
    setActiveStep((step || step===0) ? step : activeStep + 1);
  };

  const singlePetConditionCheck = () => {
    if (petList) {
      if (petList.length === 1) {
        return activeStep !== 1 ? true : false;
      } else {
        return true;
      }
    }
  };

  const getStepDetail = (step: number) => {
    switch (step) {
    case 0:
      return (
        <PetSelectionContainer/>
      );

    case 1:
      return (
        <BookingScheduleContainer />
      );
    case 2:
      return (
        petsReasonSelection.length &&
        <ReasonForVisitContainer
          setIsLoading={setDisableButton}
          setActiveStep={setActiveStep}
          handleMixPanelLog={handleMixPanelLog}
        />
      );
    case 3:
      return (
        <ConfirmDropoffToggleContainer
          setActiveStep={setActiveStep}
          handleMixPanelLog={handleMixPanelLog}
        />
      );
    case 4:
      return (
        <BookingReviewContainer
          activeStep={activeStep}
          setActiveStep={setActiveStep}
          selectedSlot={selectedSlot}
        />
      );
    case 5:
      return (
        <ConfirmUrgentVisitToggleContainer
          onConfirm={() => {
            resetUrgentVisit();
            if (selectedPets && selectedPets.length > 0) {
              setUrgentSelectedPets(selectedPets);
              setUrgentStep(UrgentVisitStep.TIME_SELECTION);
            }
            setAppointmentsForm(null);
            openModal(MODALS.URGENT_VISIT_MODAL);
          }}
          onCancel={() => {
            setActiveStep(2);
            handleMixPanelLog(MIXPANEL_EVENTS.USER_SWITCH_TO_IN_ROOM_VISIT, "pop_up");
          }}
        />
      );
    default:
      return null;
    }
  };

  const getModalIcon = ()=>{
    switch (bookingAppointmentType) {
    case CREATE_BOOKING_TYPE.DROPOFF_BOOKING:
      return <DropOffIcon width={40} height={40} />;
    default:
      return <DoctorVisitIcon width={40} height={40} />;
    }
  };
  const getModalTitle = ()=>{
    switch (bookingAppointmentType) {
    case CREATE_BOOKING_TYPE.DROPOFF_BOOKING:
      return "Drop-Off Visit";
    default:
      return "Doctor Visit";
    }
  };
  const getModalText = ()=>{
    switch (bookingAppointmentType) {
    case CREATE_BOOKING_TYPE.DROPOFF_BOOKING:
      return "Conveniently drop your pet off for care, and we’ll notify you when they’re ready—pick them up when it works best for you.";
    default:
      return "Comprehensive care, including wellness exams, sick visits, and complex medical needs with a hospital doctor";
    }
  };

  useEffect(() => {
    if (petList && petList.length == 0) {
      openModal(MODALS.ADD_A_PET);
    } else if (selectedPets.length == 0) {
      setActiveStep(0);
    } else if (selectedPets.length != 0 && !appointmentForm?.time) {
      setActiveStep(1);
    } else {
      setActiveStep(2);
    }
  }, []);

  useEffect(() => {
    if (appointmentCreatedV2) {
      if (appointmentCreatedV2.slotUnavailable) {
        setAppointmentErrorCode(appointmentCreatedV2?.messages[0]?.split(":")[0].toLowerCase());
        handleMixPanelLog(MIXPANEL_EVENTS.FIND_AVAILABILITY, "unavailable_timeslot");
        openModal(MODALS.SELECTED_TIME_UNAVAILABLE);

        return;
      }
      setAppointmentErrorCode("");
      resetCurrentBookingStep();
      closeModal();
      openModal(MODALS.UPDATED_BOOKING_CONFIRMATION_MODAL);
      // to reset the promocode state to default
      setPromoCodeData([]);
    }
  }, [appointmentCreatedV2]);

  useEffect(() => {
    if (selectedPets.length) {
      resetReasonsNavigationStore();
      const petReasonSelectionData= selectedPets.map((pet)=>(
        { petId: pet.id, selectedReasonCategory: "", selectedReasons: [], currentSelectionState: 0 as 0, additionalDescription: "" }
      ));

      setPetsReasonSelection(petReasonSelectionData);
    }
  }, [selectedPets]);

  useEffect(() => {
    if (appointmentForm?.day && appointmentForm?.selectedSlotLabel) {
      setSelectedDate(appointmentForm?.day);
      setSelectedSlot(appointmentForm?.selectedSlotLabel);
    } else {
      setSelectedDate("");
      setSelectedSlot("");
    }
    if (appointmentForm?.time) {
      const availableDate = fromUnixToFullDateNum(+appointmentForm?.time!, "UTC");

      setAvailableDate(availableDate);
      setBookingDate(`${availableDate.month} ${availableDate.day} ${availableDate.year} `);
    }
  }, [appointmentForm]);

  useEffect(() => {
    if (appointmentForm?.day && appointmentForm?.selectedSlotLabel) {
      setSelectedDate(appointmentForm?.day);
      setSelectedSlot(appointmentForm?.selectedSlotLabel);
    } else {
      setSelectedDate("");
      setSelectedSlot("");
    }
  }, [appointmentForm]);

  if (currentStep === 5) {
    return (
      <div className="h-full">
        <SelectedTimeUnavailableModal />
      </div>
    );
  }

  return (
    <div className="h-full flex flex-col justify-between px-3">
      <div className="w-full flex justify-between">
        {(activeStep > 0) && singlePetConditionCheck() ? (
          <ArrowBackIcon
            onClick={handleBackStep}
            className="text-light-black cursor-pointer"
          />
        ) : (
          <span></span>
        )}
        {(activeStep !== 3 && activeStep !== 5) &&
        <CloseIcon
          onClick={handleCloseModal}
          className="text-light-black cursor-pointer"
        />}
      </div>
      {activeStep !== 3 && activeStep !== 5 &&
      <div className="flex flex-col gap-2 items-center">
        <div className="flex items-center justify-center bg-taupe-4 rounded-full p-2 h-fit">
          {getModalIcon()}
        </div>
        <div className="flex flex-col items-center gap-1">
          <div className="font-semibold text-2xl">
            {getModalTitle()}
          </div>
          <div className="text-xs text-center w-full 2xl:w-96">
            {getModalText()}
          </div>
        </div>
      </div>}
      {activeStep !== 3 && activeStep !== 5 &&
      <div className="my-4 w-full flex flex-col gap-3">
        <CustomLinearProgressBar totalSteps={(petList && petList.length === 1) ? 3 :4} currentStep={(petList && petList.length === 1) ? activeStep-1 :activeStep} />
        {/* {activeStep !== 4 && <ExpressAppointmentDetailsIndicator />} */}
      </div>}
      <div className="h-full flex flex-col gap-2 items-center
      justify-start min-h-0 overflow-y-auto overflow-x-hidden !w-full px-2 scrollbar-thin" ref={scrollRef}>
        {getStepDetail(activeStep)}
      </div>
      {activeStep !== 3 && activeStep !== 5 &&
      <div className="flex flex-col gap-2 pb-1 pt-1.5 mt-2">
        <StyledBookingFlowButton
          color="primary"
          disabled={disableValidation(activeStep)}
          size="small"
          className="w-full"
          onClick={handleCtaClick}
        >
          {getCtaText()}
        </StyledBookingFlowButton>
        {activeStep === 4 &&
        <div className="text-xs text-center" >
            By continuing, you agree to the{" "}
          <a href="http://goodvets.com/terms" target="_blank" rel="noreferrer">
            <span className="font-semibold decoration-1 cursor-pointer underline">
               GoodVets Terms of Service
            </span>
          </a>&nbsp;
          and if applicable, the&nbsp;
          <a href="http://goodvets.com/promotion-terms" target="_blank" rel="noreferrer">
            <span className="underline font-semibold">GoodVets Promotions Terms of Service.</span>
          </a>
        </div>}
      </div>}
    </div>
  );
};

export default BookAVisitUpdatedModal;
